import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextField from 'src/components/TextField';
import { useTranslation } from 'react-i18next';
import { COMPANIES_PAGE_QUERY } from 'src/graphql/company/query';
import client from 'src/utils/api/client';
import s from './ColumnFilters.styles';

const ColumnFilterCompany = ({
  value,
  onChange,
  onRemove,
  column: { label },
  companyTypes,
}) => {
  const { t } = useTranslation();
  const [popupActive, setPopupActive] = useState(false);

  let companyTypeId = null;
  switch (label) {
  case t('COLUMN_FACTORY_NAME'):
    companyTypeId = (companyTypes || []).find(c => c.currentVersion.name === 'Factory')?.id;
    break;
  case t('COLUMN_PROGRAM'):
    companyTypeId = (companyTypes || []).find(c => c.currentVersion.name === 'Program')?.id;
    break;
  default:
    console.log(`Unknown label:${label}`);
  }

  const ref = useRef(null);
  useEffect(() => {
    const handleClickOutside = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        setPopupActive(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  const [localValue, setLocalValue] = useState(value?.text || '');

  const onSubmit = async () => {
    const response = await client.query({
      query: COMPANIES_PAGE_QUERY,
      variables: {
        limit: 999,
        offset: 0,
        q: localValue,
        columnFilters: [
          {
            field: 'company_types',
            value: JSON.stringify([companyTypeId]),
          },
        ],
      },
    });
    let companyIds = (response?.data?.companies || []).map(c => c.id);
    if (companyIds.length === 0) {
      companyIds = [0];
    }
    onChange({ text: localValue, ids: companyIds });
    setPopupActive(false);
  };

  return (
    <s.FilterWrapper>
      <s.FilterLabel changed={!!value?.text} onClick={() => setPopupActive(true)}>
        <s.FilterRemoveBtn name="cross" onClick={onRemove} />
        {label}: {value?.text || t('ALL')}
      </s.FilterLabel>
      {popupActive && (
        <s.MorePopup ref={ref}>
          <s.PopupTextField>
            <TextField
              onChange={e => setLocalValue(e.target.value)}
              onKeyUp={e => e.keyCode === 13 && onSubmit()}
              placeholder={t('FILTER_BY_STRING')}
              value={localValue}
            />
            {localValue ? (
              <s.TextConfirmButton onClick={onSubmit}>
                <s.MoreSearchIcon check name="check" />
              </s.TextConfirmButton>
            ) : (
              <s.MoreSearchIcon funnel name="funnel" />
            )}
          </s.PopupTextField>
        </s.MorePopup>
      )}
    </s.FilterWrapper>
  );
};

ColumnFilterCompany.propTypes = {
  column: PropTypes.shape({
    label: PropTypes.string,
  }),
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  value: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    }),
  ),
  companyTypes: PropTypes.arrayOf(PropTypes.shape({})),
};

export default React.memo(ColumnFilterCompany);
